import { Box, Toolbar } from "@mui/material";
import { Outlet } from "react-router-dom";
import TopBar from "./TopBar";
import Sidebar from "./Sidebar";
import { useAuth } from "../context/AuthContext";
import NoCompanyAccess from "../components/common/NoCompanyAccess";
import { useState } from "react";

const DRAWER_WIDTH_EXPANDED = 240;
const DRAWER_WIDTH_COLLAPSED = 76; // enterprise: ~72-80px

interface AppLayoutProps {
  companies: any[];
  onLogout: () => void;
  onCompaniesRefresh: () => Promise<void>; 
}

export default function AppLayout({ companies, onLogout, onCompaniesRefresh }: AppLayoutProps) {
  const { selectedCompany, setSelectedCompany } = useAuth();
  const [collapsed, setCollapsed] = useState(false);

  const drawerWidth = collapsed
    ? DRAWER_WIDTH_COLLAPSED
    : DRAWER_WIDTH_EXPANDED;

  return (
    <Box sx={{ display: "flex", minHeight: "100vh" }}>
      <TopBar
        drawerWidth={drawerWidth}
        companies={companies}
        selectedCompany={selectedCompany}
        onSelectCompany={setSelectedCompany}
        onLogout={onLogout}
        onToggleSidebar={() => setCollapsed((p) => !p)}
        sidebarCollapsed={collapsed}
        onCompaniesRefresh={onCompaniesRefresh}
      />

      <Sidebar drawerWidth={drawerWidth} collapsed={collapsed} />

      <Box
        component="main"
        sx={{
          display: "flex",
          flexDirection: "column",
          height: "100vh",
          flexGrow: 1,
          backgroundColor: "background.default",
          p: 3,
          transition: "margin-left 0.25s ease", // wizualnie miękko
        }}
      >
        <Toolbar />
        {companies && companies.length === 0 ? (
          <NoCompanyAccess />
        ) : (
          <Box sx={{ flex: 1, minHeight: 0, overflow: "hidden", display: "flex", flexDirection: "column" }}>
            <Outlet context={{ selectedCompany }} />
          </Box>
        )}
      </Box>
    </Box>
  );
}